import * as pathToRegexp from 'path-to-regexp'
import { isGeografi, isPageNotFound, isParti, PageType, ParentGeografi } from '../domain'
import { bydelRoute } from './app/bydel'
import { landsoversiktRoute } from './app/landsoversikt'
import { fylkeRoute } from './app/fylke'
import { kommuneRoute } from './app/kommune'
import { kretsRoute } from './app/krets'
import { partiRoute } from './app/parti'
import { pageNotFoundRoute } from './app/page-not-found'
import { idFrom } from '../api'

export const routes = [
  bydelRoute,
  fylkeRoute,
  kommuneRoute,
  kretsRoute,
  landsoversiktRoute,
  partiRoute,

  /* page not found must be last element */
  pageNotFoundRoute
]

const urlGenerators = {
  Nasjon: pathToRegexp.compile(landsoversiktRoute.path),
  Fylke: pathToRegexp.compile(fylkeRoute.path),
  Kommune: pathToRegexp.compile(kommuneRoute.path),
  Bydel: pathToRegexp.compile(bydelRoute.path),
  Krets: pathToRegexp.compile(kretsRoute.path),
  Parti: pathToRegexp.compile(partiRoute.path)
}

export function createUrlFor(grunndata: PageType, locale: string): string {
  if (isGeografi(grunndata)) {
    const { navn } = grunndata
    const id = idFrom(grunndata)
    return urlGenerators[grunndata.type]({ id, navn, locale })
  } else if (isParti(grunndata)) {
    return urlGenerators['Parti']({ id: grunndata.id, locale })
  } else if (isPageNotFound(grunndata)) {
    return `/valg/2019/resultat/${locale}/404`
  } else {
    throw new Error('Ukjent grunndata: ' + JSON.stringify(grunndata))
  }
}

export function createUrlForParti(id: string, locale: string) {
  return urlGenerators['Parti']({ id, locale })
}

export function landsoversiktUrl(locale: string = 'nb') {
  return urlGenerators['Nasjon']({ locale })
}

export function createParentUrlFor(grunndata: PageType, locale: string): string {
  if (isGeografi(grunndata)) {
    const { navn } = grunndata
    const id = idFrom(grunndata)
    return urlGenerators[grunndata.type]({ id, navn, locale })
  } else if (isParti(grunndata)) {
    return urlGenerators['Parti']({ id: grunndata.id, locale })
  } else if (isPageNotFound(grunndata)) {
    return `/valg/2019/resultat/${locale}/404`
  } else {
    throw new Error('Ukjent grunndata: ' + JSON.stringify(grunndata))
  }
}
